export default __webpack_public_path__ + "static/media/eft-icon.761d0b6c.png";